import React, { useState } from 'react'
import { hot } from 'react-hot-loader';

import { useParams } from 'react-router-dom';

import BreadCrumb from '../../../../components/BreadCrumb';
import Container from '../../../../components/Container';
import PageTitle from '../../../../components/PageTitle';
import TitleBar from '../../../../components/TitleBar';

import ExperimentRootItems from './components/ExperimentRootList';

import { fiscalYearExperimentsUrl, fiscalYearsUrl } from '../../urls';
import listExperimentRootItems from '../../../../sdk/apis/listExperimentRootItems';

import { retrieveExperiment } from '../../../../sdk/apis';
import { fisYear2Year } from '../FiscalYears/components/FiscalYearList';
import BottomBar from '../../../../components/BottomBar';

const ExperimentRoot = () => {
  const { year, ex_id } = useParams();
  const fiscalYear = parseInt(year);
  const experimentId = parseInt(ex_id);

  const [experimentInfo, setExperimentInfo] = useState(null);
  const [experimentRootItems, setExperimentRootItems] = useState(null);


  if (experimentInfo === null) {
    retrieveExperiment(experimentId).then((data) => {
      setExperimentInfo(data)
    });

    return null;
  };

  const breadcrumbData = [];
  breadcrumbData.push({ title: '実験一覧', url: fiscalYearsUrl(year) });
  breadcrumbData.push({ title: fisYear2Year(fiscalYear), url: fiscalYearExperimentsUrl(year, ex_id) });
  breadcrumbData.push({ title: experimentInfo.caption })


  // const experimentListArray = Array(experimentList);

  if (experimentRootItems === null) {
    listExperimentRootItems(experimentId).then((data) => {
      setExperimentRootItems(data);
    });

    return null;
  }


  return (
    <>
      <TitleBar />
      <Container>
        <BreadCrumb data={breadcrumbData} />
        <PageTitle>{experimentInfo.caption}</PageTitle>

        <ExperimentRootItems experiment={experimentInfo} files={experimentRootItems} />

      </Container>
      <BottomBar />
    </>
  );
};

export default ExperimentRoot;
